<template>
  <el-dialog
    class="pop"
    title=""
    :visible.sync="dialogVisible"
    width="100%"
    :before-close="handleClose"
  >
    <div class="bottom-pop justify-between items-center">
      <div class="pop-left">
        <h3>
          Welcome to KARON ECO-VALVE , please select the website language ?
        </h3>
        <p>欢迎访问冠龙节能，请选择网站语言？</p>
      </div>
      <div class="pop-btn">
        <button @click="chosePop('c')">中文</button>
        <button @click="chosePop('en')">English</button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: true,
    };
  },
  methods: {
    handleClose(done) {
      this.dialogVisible = false;
    },
    chosePop(type) {
      if (type == "c") {
        this.$router.push({
          path: `/`,
        });
      } else {
        this.$router.push({
          path: `/en_index`,
        });
      }
      window.localStorage.setItem("dialogVisible", "1");
      this.dialogVisible = false;
    },
  },
  created() {
    this.dialogVisible =
      window.localStorage.getItem("dialogVisible") == "1" ? false : true;
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.bottom-pop {
  padding: 70px 120px;
  background: #005bac;
  h3 {
    font-size: 24px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 31px;
  }
  p {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #ffffff;
    line-height: 21px;
    margin-top: 8px;
  }
  button {
    background: #005bac;
    border: 2px solid #ffffff;
    padding: 13px 0;
    width: 120px;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #ffffff;
    line-height: 24px;
    margin-left: 16px;
    cursor: pointer;
  }
}
@media screen and (max-width: 768px) {
  .bottom-pop {
    flex-direction: column;
    padding: 60px 20px 80px;
    align-items: flex-start;
    p {
      margin-top: 12px;
    }
    .pop-btn {
      margin-top: 40px;
    }
    button {
      margin-right: 16px;
      margin-left: 0;
    }
  }
}
</style>
<style>
.pop .el-dialog {
  position: fixed;
  bottom: 0;
  margin: 0;
}
.pop .el-dialog__header {
  display: none;
}
.pop .el-dialog__body {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/en/common/pop.vue